// extracted by mini-css-extract-plugin
module.exports = {"meta__date":"Meta-module--meta__date--3FNDv"};